export type KpiMetric = {
  label: string;
  formatted: string;
};

export type KpiStyle = {
  orientation?: "horizontal" | "vertical";
  frameTitle?: string;
  frameBorderColor?: string;
  frameBorderWidth?: number;
  frameRadius?: number;
  framePadding?: number;
  columns?: number;
  valueFontSize?: number;
  labelFontSize?: number;
  labelGap?: number;
  rowGap?: number;
  cardRadius?: number;
  cardBorderWidth?: number;
  cardHorizontalPadding?: number;
  cardTopPadding?: number;
  cardBottomPadding?: number;
  cardBackground?: string;
  cardBorderColor?: string;
  headerColor?: string;
  valueColor?: string;
  headerFontWeight?: number;
  valueFontWeight?: number;
};

export function KpiCard({ metrics, style }: { metrics: KpiMetric[]; style: KpiStyle }) {
  const {
    orientation = "horizontal",
    frameTitle = "",
    frameBorderColor = "#cbd5e1",
    frameBorderWidth = 1,
    frameRadius = 12,
    framePadding = 12,
    columns = metrics.length > 1 ? 2 : 1,
    valueFontSize = 42,
    labelFontSize = 14,
    labelGap = 10,
    rowGap = 18,
    cardRadius = 10,
    cardBorderWidth = 1,
    cardHorizontalPadding = 12,
    cardTopPadding = 10,
    cardBottomPadding = 14,
    cardBackground = "#ffffff",
    cardBorderColor = "#cbd5e1",
    headerColor = "#334155",
    valueColor = "#0f172a",
    headerFontWeight = 700,
    valueFontWeight = 700
  } = style;
  const computedColumns = columns ?? (orientation === "vertical" ? 1 : (metrics.length > 1 ? 2 : 1));
  const gridColumns = orientation === "vertical" ? 1 : computedColumns;

  return (
    <div
      style={{
        border: `${frameBorderWidth}px solid ${frameBorderColor}`,
        borderRadius: frameRadius,
        padding: framePadding,
        boxSizing: "border-box",
        width: "100%"
      }}
    >
      {frameTitle.trim() ? (
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: "#0f172a",
            textAlign: "center",
            background: "#e2e8f0",
            borderRadius: 6,
            padding: "6px 10px",
            marginBottom: 10,
            width: "100%",
            boxSizing: "border-box"
          }}
        >
          {frameTitle}
        </div>
      ) : null}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${Math.max(1, gridColumns)}, 1fr)`,
          gap: rowGap
        }}
      >
        {metrics.map((metric, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: `${cardTopPadding}px ${cardHorizontalPadding}px ${cardBottomPadding}px`,
              background: cardBackground,
              border: `${cardBorderWidth}px solid ${cardBorderColor}`,
              borderRadius: cardRadius,
              textAlign: "center",
              minWidth: 0
            }}
          >
            <div
              style={{
                fontSize: labelFontSize,
                fontWeight: headerFontWeight,
                color: headerColor,
                marginBottom: labelGap,
                lineHeight: 1.2,
                wordBreak: "break-word"
              }}
            >
              {metric.label}
            </div>
            <div
              style={{
                fontSize: valueFontSize,
                fontWeight: valueFontWeight,
                color: valueColor,
                lineHeight: 1.1,
                wordBreak: "break-word"
              }}
            >
              {metric.formatted}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
